/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminLoginRequest
 */
export interface AdminLoginRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminLoginRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof AdminLoginRequest
     */
    password: string;
}

/**
 * Check if a given object implements the AdminLoginRequest interface.
 */
export function instanceOfAdminLoginRequest(value: object): value is AdminLoginRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function AdminLoginRequestFromJSON(json: any): AdminLoginRequest {
    return AdminLoginRequestFromJSONTyped(json, false);
}

export function AdminLoginRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminLoginRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'password': json['password'],
    };
}

export function AdminLoginRequestToJSON(json: any): AdminLoginRequest {
    return AdminLoginRequestToJSONTyped(json, false);
}

export function AdminLoginRequestToJSONTyped(value?: AdminLoginRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'password': value['password'],
    };
}

